import { css, html, LitElement } from "lit";

import "../components/navbar";
import "../components/map";

import { setTitle, trackPage } from "../common/client";
import { websiteStyles } from "../styles/website";

export class LiveMapPage extends LitElement {
  static styles = [
    websiteStyles,
    css`
      :host {
        display: block;
        width: 100vw;
        height: 100vh;
        background: #FFF;
        color: #000;
        padding-top: 70px;
      }          
    `,
  ];

  connectedCallback() {
    super.connectedCallback();

    trackPage();
    setTitle("Live Map");
  }

  render() {
    return html`
      <navbar-component></navbar-component>
      <map-component></map-component>
    `;
  }
}

customElements.define("live-map-page", LiveMapPage);
